import { useTranslation } from 'react-i18next';
import { useModalContext } from '../../contexts/ModalContext';
import AppModal from './Modal';

const ModalSpinner = () => {
    const { t } = useTranslation();

    const { spinner } = useModalContext();

    if (!spinner) return <></>;

    return (
        <AppModal>
            <div style={{ alignSelf: 'center', textAlign: 'center' }}>
                <p>{t('feedback.please_wait_request_processed')}</p>
                <div
                    className="lds-hourglass"
                    style={{ marginTop: '1rem' }}
                ></div>
            </div>
        </AppModal>
    );
};

export default ModalSpinner;
